import { SystemStyleObject } from '@chakra-ui/react';
import { ColorMode } from '@allergan-data-labs/alle-elements-core';
import { getActionListItemStyles } from './action-list-item.theme';

export const getActionListItemOptionStyles = (
  colorMode: ColorMode
): SystemStyleObject => {
  return {
    position: 'relative',
    ...getActionListItemStyles(colorMode),
  };
};

export const getActionListOptionIconStyles = (
  colorMode: ColorMode,
  isDisabled: boolean
): SystemStyleObject => {
  return {
    color: `${colorMode}.${
      isDisabled ? 'Icon/Neutral/Disabled/Default' : 'Icon/Neutral/Default'
    }`,
  };
};

export const getActionListItemOptionEmptyCheckboxStyles =
  (): SystemStyleObject => {
    return {
      position: 'absolute',
      left: '4px',
      top: '4px',
    };
  };
